import React from "react";
import middleware from "../../middleware";

const Divider = React.createClass({
  getDefaultProps() {
    return {
      disabled: true
    };
  },

  render() {
    const props = this.props;
    let className = props.className || "";
    const rootPrefixCls = props.rootPrefixCls;
    className += " " + `${rootPrefixCls}-item-divider`;
    return <li className={className} />;
  }
});

export default middleware(Divider, "Menu.Divider");
// export default Divider;



// WEBPACK FOOTER //
// ./_rc-menu-4.13.0/src/Divider.jsx